<template>
  <div v-if="isAvailableBoxes" class="basket-box-view">
    <DefImg :result="box.picture" />
    <DefLinkBrown @click="handlerOpenCasket">
      {{ messages.selectAccessory }}
    </DefLinkBrown>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import useModalAside from '@use/useModalAside/useModalAside';
import BasketBoxModal from '@components/Basket/BasketBox/BasketBoxModal/BasketBoxModal.vue';
import DefLinkBrown from '@components/Def/DefLink/DefLinkBrown.vue';
import useBasketState from '@use/useBasketState';

export default {
  name: 'BasketBoxView',
  components: {
    DefLinkBrown,
    DefImg,
  },
  props: ['result'],
  data() {
    return {
      modalAside: useModalAside(),
      basketState: useBasketState(),
    };
  },
  computed: {
    ...mapState({
      messages: ({ basket }) => basket.data.messages,
    }),
    id() {
      return this.result?.offer?.id || this.result?.id;
    },
    box() {
      return this.result.box;
    },
    boxId() {
      return this?.box?.offer?.id || this?.box?.id;
    },
    isAvailableBoxes() {
      return this?.result?.boxes?.filter((el) => el.isAvailable)?.length > 0;
    },
  },
  methods: {
    async handlerOpenCasket() {
      await this.basketState.close();

      this.modalAside.show(
        BasketBoxModal,
        { result: this.result },
        {
          width: '580px',
          afterRemove: () => {
            this.basketState.open();
          },
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.basket-box-view {
  display: flex;
  align-items: center;
  gap: 8px;
  grid-column-start: 1;
  grid-column-end: 3;
  margin-top: 8px;
  @include point-md {
    grid-column-start: 2;
    grid-column-end: 3;
  }
  :deep(.def-img) {
    max-width: 24px;
    @include point-md {
      max-width: 32px;
    }
  }
  :deep(.def-link-brown) {
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
    text-transform: uppercase;
  }
}
</style>
